import Seo, { pageSeo } from "../components/Seo";
import React, { useState } from "react";
import { ChevronLeft, ChevronRight, X, ZoomIn } from "lucide-react";
import { Dialog, DialogContent } from "../components/ui/dialog";
import { PageBanner, Reveal, SectionTitle } from "../components/Shared";
import { galleryItems, galleryCategories, facilityPhotos } from "../mock";

const Gallery = () => {
  const [filter, setFilter] = useState("All");
  const [active, setActive] = useState(null); // index within filtered list

  const items = filter === "All" ? galleryItems : galleryItems.filter((g) => g.category === filter);
  const current = active !== null ? items[active] : null;

  const step = (d) => setActive((i) => (i + d + items.length) % items.length);

  return (
    <div data-testid="gallery-page">
    <Seo {...pageSeo.gallery} />
      <PageBanner title="Gallery" subtitle="A look inside Anjaneya Inks and Coating - our gate, facility, production house, delivery unit and stock yard." image={facilityPhotos.mainGate.src} crumbs={["Gallery"]} />

      <section className="section bg-white">
        <div className="container-dic">
          <Reveal><SectionTitle>Photo Gallery</SectionTitle></Reveal>

          <div className="flex flex-wrap justify-center gap-2 mb-10" role="tablist">
            {galleryCategories.map((c) => (
              <button
                key={c}
                type="button"
                role="tab"
                aria-selected={filter === c}
                onClick={() => { setFilter(c); setActive(null); }}
                className={`filter-pill ${filter === c ? "is-active" : ""}`}
                data-testid={`gallery-filter-${c.toLowerCase()}`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-5" data-testid="gallery-grid">
            {items.map((g, i) => (
              <Reveal key={g.id} delay={(i % 3) * 70}>
                <button type="button" className="gallery-item" onClick={() => setActive(i)} data-testid={`gallery-item-${g.id}`}>
                  <img src={g.src} alt={g.alt} loading="lazy" />
                  <span className="gallery-item__overlay">
                    <ZoomIn size={26} />
                    <span className="gallery-item__caption">{g.caption}</span>
                    <span className="gallery-item__cat">{g.category}</span>
                  </span>
                </button>
              </Reveal>
            ))}
          </div>

          <p className="text-center text-[12.5px] text-[#8a8a8a] mt-10">
            Photos shown are placeholders and will be replaced with the company's own photographs.
          </p>
        </div>
      </section>

      <Dialog open={current !== null} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-5xl p-0 bg-black border-0 overflow-hidden [&>button]:hidden" data-testid="gallery-lightbox">
          {current && (
            <div className="relative">
              <img src={current.src} alt={current.alt} className="w-full max-h-[80vh] object-contain bg-black" />
              <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/80 to-transparent p-5 text-white">
                <div className="text-[12px] uppercase tracking-wider text-[#8cc63f]">{current.category}</div>
                <div className="text-[18px] font-bold">{current.caption}</div>
              </div>
              <button type="button" onClick={() => setActive(null)} className="lightbox-btn top-3 right-3" aria-label="Close" data-testid="lightbox-close"><X size={20} /></button>
              <button type="button" onClick={() => step(-1)} className="lightbox-btn left-3 top-1/2 -translate-y-1/2" aria-label="Previous" data-testid="lightbox-prev"><ChevronLeft size={22} /></button>
              <button type="button" onClick={() => step(1)} className="lightbox-btn right-3 top-1/2 -translate-y-1/2" aria-label="Next" data-testid="lightbox-next"><ChevronRight size={22} /></button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Gallery;
